import script from "./BetView.vue?vue&type=script&setup=true&lang=js"
export * from "./BetView.vue?vue&type=script&setup=true&lang=js"

import "./BetView.vue?vue&type=style&index=0&id=8cfa9a80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cfa9a80"]])

export default __exports__